















import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherLayout from '../../components/TedsLauncherLayout/TedsLauncherLayout.vue'
import TedsLauncherProfileInformation from '../../components/TedsLauncherProfileInformation/TedsLauncherProfileInformation.vue'
import TedsLauncherUiSettings from '../../components/TedsLauncherUiSettings/TedsLauncherUiSettings.vue'

@Component({
  components: {
    TedsLauncherLayout,
    TedsLauncherProfileInformation,
    TedsLauncherUiSettings,
  },
})
export default class Settings extends Vue {}
